/**
 * @generated SignedSource<<77d73adfa897904b1a70a0a9ea3ce8cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsFiltersModalFragment_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersFragment_session">;
  readonly " $fragmentType": "LessonsFiltersModalFragment_session";
};
export type LessonsFiltersModalFragment_session$key = {
  readonly " $data"?: LessonsFiltersModalFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersModalFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsFiltersModalFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonsFiltersFragment_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "0196cd4cc9c03334182d0154adf98246";

export default node;
